<template>
  <div class="card-form">
    <el-radio-group v-model="activeName" @input="handleInput" size="small">
      <el-radio-button label="1">{{ adequate }}</el-radio-button>
      <el-radio-button label="2">{{ insufficient }}</el-radio-button>
      <el-radio-button label="3">{{ seriouslyInsufficient }}</el-radio-button>
      <el-radio-button label="all">{{
        $l('INDEX.tips_all') || '全部'
      }}</el-radio-button>
    </el-radio-group>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header'
import PageMain from './main.vue'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return {
      usePage: true,
      activeName: '3',
      tmpForm: {},
      levelGroupData: [],
    }
  },
  mounted() {
    this.getLevelGroup({})
  },
  computed: {
    adequate() {
      let adequateNumber = this.levelGroupData
        .filter((e) => e.label == '1')
        .map((e) => e.value)
        .join('')
      return (
        (this.$l('form_label_status_adequate') || '充足') +
        ` (${adequateNumber ? adequateNumber : 0})`
      )
    },
    insufficient() {
      let insufficientNumber = this.levelGroupData
        .filter((e) => e.label == '2')
        .map((e) => e.value)
        .join('')
      return (
        (this.$l('form_label_status_insufficient') || '不足') +
        ` (${insufficientNumber ? insufficientNumber : 0})`
      )
    },
    seriouslyInsufficient() {
      let seriouslyInsufficientNumber = this.levelGroupData
        .filter((e) => e.label == '3')
        .map((e) => e.value)
        .join('')
      return (
        (this.$l('form_label_status_seriously_insufficient') || '严重不足') +
        ` (${seriouslyInsufficientNumber ? seriouslyInsufficientNumber : 0})`
      )
    },
  },
  methods: {
    getLevelGroup(form) {
      this.$api.ecomAmzFbaInvMonitorLevelGroupApi({ ...form }).then((res) => {
        this.levelGroupData = res?.body?.data || []
      })
    },
    getData(form) {
      this.loading = true
      if (this.activeName > 0 && this.activeName != 'all') {
        form.alertLevelList = [this.activeName]
      } else {
        form.alertLevelList = []
      }
      this.$api
        .ecomAmzFbaInvMonitorListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.tmpForm = form
          this.getLevelGroup(form)
          this.checkedRow = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleInput() {
      this.page.curPage = 1
      this.getData(this.tmpForm)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__header {
  margin: 0 !important;
}
::v-deep .is-active {
  color: #409eff !important;
}
</style>
